var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWorkspaceMarketingcomponent = function SvgWorkspaceMarketingcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 3,
    fill: "#CC61B5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 15.896c0 2.061 1.612 3.732 3.6 3.732h.37l.891 4.39c.252 1.241 1.601 1.865 2.661 1.23L16 24.365c.557-.333.9-.949.9-1.615v-2.37a13.568 13.568 0 0 1 3.583 1.902l2.361 1.748c.232.171.509.263.793.263.753 0 1.363-.632 1.363-1.413V8.913c0-.78-.61-1.413-1.363-1.413a1.33 1.33 0 0 0-.793.263l-2.36 1.748a13.413 13.413 0 0 1-7.988 2.654H10.6c-1.988 0-3.6 1.67-3.6 3.731Zm14.53-4.866 1.67-1.237v12.206l-1.67-1.236a15.17 15.17 0 0 0-9.034-3.001H10.6c-.994 0-1.8-.835-1.8-1.866 0-1.03.806-1.866 1.8-1.866h1.896c3.24 0 6.398-1.049 9.033-3Zm-6.43 8.856a13.26 13.26 0 0 0-2.29-.255l.812 4.002 1.478-.884v-2.863Z",
    fill: "#fff"
  })));
};
export default SvgWorkspaceMarketingcomponent;